/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Speakers_Metrics_Events_SuffixInputs */



/**
* | output |
* | --- |
* | "{name} Events" |
*
* @param {Speakers_Metrics_Events_SuffixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_events_suffix = /** @type {((inputs: Speakers_Metrics_Events_SuffixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Events_SuffixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} Events`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} Events`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.name} Events`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.name} Events`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.name} Events`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.name} Events`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.name} Events`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.name} Events`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.name} Events`)
	return /** @type {LocalizedString} */ (`${i?.name} Events`)
});